import UploadDoc from "dataphi-react-components/dist/Containers/DataphiUploadDocContainer/Component/UploadDocComponent";
import React, { Component } from "react";
import { Col, Grid, Modal, Row } from "react-bootstrap";

import JPGImg from "../../../Assets/jpg_icon.png";
import PDFIcon from "../../../Assets/pdf_icon.png";
import Image from "../../../Assets/upload.png";
import Phi from "../../../Phi/Phi";
import history from "../../../history";

import Constants from "../../../Phi/Constants";
import Leftbar from "../../DashboardContainer/Component/Leftbar";
import "./UploadDocument.css";
import RootLayout from "../../../Components/shared/RootLayout";

const styleDefs = {
  dataphiUploadDocUploadBlock: "hsg-upload-doc-block",
  dataphiUploadDocUploadImgBtn: "hsg-upload-doc-upload-img-btn",
  dataphiUploadDocUploadBlockContent: "hsg-upload-doc-upload-block-content",
  dataphiUploadDocTitle: "hsg-upload-doc-title",
  dataphiUploadDocLabel: "hsg-upload-doc-label",
  dataphiUploadDocUploadImgUploadBtnText:
    "hsg-upload-doc-upload-img-upload-btn-text",
  dataphiUploadDocUploadImgBtnDisabled:
    "hsg-upload-doc-upload-img-btn-disabled",
  dataphiUploadDocUploadImg: "hsg-upload-doc-upload-img",
  dataphiUploadDocUploadImgDefault: "hsg-upload-doc-upload-img-default",
  dataphiUploadDocUploadBtn: "hsg-upload-doc-upload-btn",
  dataphiUploadDocError: "hsg-error",
};

const fileErrorMessage = {
  fileSize: "File exceeds the specified limit",
};

const getAdditionalDoc = (reqDoc) => {
  let obj = reqDoc.map((i) => ({
    ...i,
    custom_field: JSON.parse(i.custom_field)[0],
  }));
  return (
    (obj.length &&
      obj.filter(
        (i) => i.custom_field?.json_value.type === "additionalDocFromSchool"
      )) ||
    []
  );
};
class UploadDocument extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showConfirmationModal: false,
      removeDocParams: [],
      fileUploadErrorMessage: null,
      fileName: null,
    };
  }

  componentWillMount() {
    let organization = JSON.parse(Phi.Storage.getItem("organization"));

    if (organization) {
      if (this.props.contentId) {
        this.props.fetchAllDocs(this.props.contentId);
      } else {
        this.props.getProgramByOrganization(organization[0].org_id);
      }
    }
    //this.redirect(this.props)
  }

  redirect = ({ contentId }) => !contentId && history.replace("/dashboard");

  componentWillReceiveProps(nextProps) {
    if (this.props.contentId !== nextProps.contentId) {
      nextProps.contentId && this.props.fetchAllDocs(nextProps.contentId);
    }

    if (
      !!!this.props.contentId &&
      nextProps.updatedContentNodeId &&
      !!!this.props.updatedContentNodeId
    ) {
      this.props.updateOrganization(
        nextProps.inOrganizationId,
        nextProps.updatedContentNodeId
      );
    }
    //this.redirect(nextProps)
  }

  showDoc = (schoolFileObj) => {
    let fileName = schoolFileObj.custom_field.json_value.file_name;
    let fileSize = schoolFileObj.custom_field.json_value.size;
    let fileUrl = schoolFileObj.custom_field.json_value.content_url;
    let fileType = schoolFileObj.custom_field.json_value.mimeType;

    return (
      <React.Fragment>
        <div
          style={{ maxWidth: "30%" }}
          className="document-cards not-wide-enough left"
          key={schoolFileObj.uuid}
        >
          <br />
          <div className="hsg-add-school-upload-doc-after">
            <a href={fileUrl} target="_blank">
              {fileType === "application/pdf" ? (
                <img src={PDFIcon} height="40px" width="40px" />
              ) : (
                <img src={JPGImg} height="40px" width="40px" />
              )}{" "}
              &nbsp;&nbsp;
              {`${fileName} (${Math.floor(fileSize / 1024)}K)`}
            </a>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <span
              data-icon="&#e90b;"
              className="icon-close hsg-icon-close"
              onClick={() =>
                this.switchConfirmationModal(
                  true,
                  [schoolFileObj.id, schoolFileObj.uuid, "school", null],
                  schoolFileObj.custom_field.json_value.file_name
                )
              }
            ></span>
          </div>
        </div>
      </React.Fragment>
    );
  };

  removeDoc = (id, targetID, category, chequeDetailCounter, fileGroup) => {
    this.props.removeDoc(
      id,
      targetID,
      this.props.contentId,
      category,
      fileGroup
    );
  };

  errorWhileUpload = (data) => {
    this.setState({
      fileUploadErrorMessage: fileErrorMessage[data] || "Something went wrong.",
    });
  };

  switchConfirmationModal = (val, args = [], fileName) => {
    this.setState({
      showConfirmationModal: Boolean(val),
      removeDocParams: args,
      fileName,
    });
  };

  callRemoveDoc = (removeDocParams = []) => {
    removeDocParams.length && this.removeDoc(...removeDocParams);
    this.switchConfirmationModal(false);
  };

  confirmationModal = () => (
    <Modal
      show={this.state.showConfirmationModal}
      onHide={() => this.switchConfirmationModal(false)}
    >
      <Modal.Header>
        <Modal.Title>Confirmation</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Please confirm removal of {this.state.fileName || "this document"}.{" "}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="hsg-btn-white"
          onClick={() => this.switchConfirmationModal(false)}
        >
          Close
        </button>
        <button
          className="hsg-btn yes-btn"
          onClick={() => this.callRemoveDoc(this.state.removeDocParams)}
        >
          Yes
        </button>
      </Modal.Footer>
    </Modal>
  );

  render() {
    let schoolFileObj =
      (this.props.reqDoc &&
        this.props.reqDoc.school &&
        Array.isArray(this.props.reqDoc.school) &&
        getAdditionalDoc(this.props.reqDoc.school)) ||
      [];

    return (
      <RootLayout props={this.props}>
        <div
          style={{
            display: "flex",
            padding: "2em ",
            flexDirection: "column",
            flex: 1,
          }}
        >
          {/* row 1  */}
          <div
            className="borderRadius"
            style={{
              backgroundColor: "white",
              padding: "1em 1em 1em 2em ",
              display: "flex",
              flex: 1,
              flexDirection: "column",
            }}
          >
            <div>
              <div>
                <h4> Upload</h4>
                <br />
                <span>
                  Please use this screen to upload all important medical and
                  health-related documents which are used in the School such as
                  Allergy Lists, Chronic Condition Lists, or Injury Reports.
                </span>
              </div>
              {Constants?.userPermissionMap[this.props.roleType].includes(
                Constants.userPermissionId.EDIT
              ) && (
                <Row>
                  <Col md={4} sm={4} xs={12}>
                    <div className="hsg-upload-pic">
                      <UploadDoc
                        onFileSubmit={(obj) => {
                          this.props.onFileSubmit(
                            obj,
                            this.props.contentId,
                            "additionalDocFromSchool",
                            "school"
                          );
                          this.setState({ fileUploadErrorMessage: null });
                        }}
                        fileType={[
                          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                          "application/msword",
                          "application/pdf",
                          "application/vnd.ms-excel",
                          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                        ]}
                        multiple={true}
                        maxSize={1}
                        showError={false}
                        image={Image}
                        showBadge={false}
                        progressBar={false}
                        selectedCategory={"DRAG & DROP\nor"}
                        showUploadButton={false}
                        uploadButtonText="Browse"
                        errorWhileUpload={this.errorWhileUpload}
                        styleDefs={styleDefs}
                      />
                      <p>
                        Your document should not exceed 1 MB (.doc, .xcel, .pdf)
                      </p>
                      {this.state.fileUploadErrorMessage && (
                        <p className="hsg-error">
                          {this.state.fileUploadErrorMessage}
                        </p>
                      )}
                    </div>
                  </Col>
                  <br />
                </Row>
              )}
            </div>
            <div>
              {schoolFileObj.length
                ? schoolFileObj.map((schoolFileObjItem) =>
                    this.showDoc(schoolFileObjItem)
                  )
                : null}
            </div>
          </div>
        </div>
        {this.confirmationModal()}
      </RootLayout>
    );
  }
}

export default UploadDocument;
